module.exports = __webpack_public_path__ + "img/engeland-oplossing.a2499408.png";